export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00543.e2f08ead.png";